import { initialRecommendedVehicles } from '~/constants/initialRecommendedVehicles';
import Sections from '~/constants/sections';
import { FlexWrapper } from './CarCompare.styles';
import VehicleTileLoader from './VehicleTile/VehicleTileLoader';

type OwnProps = {
  showLoadMore?: boolean;
};

const VehiclesYouMightLikeLoader = ({ showLoadMore }: OwnProps) => (
  <div
    className="flex flex-col items-center"
    data-section={Sections.VehiclesYouMightLike}
  >
    <FlexWrapper>
      {[...Array(initialRecommendedVehicles)].map((_, index) => (
        <VehicleTileLoader key={`tile-loader-${index}`} />
      ))}
    </FlexWrapper>
    {showLoadMore && <div className="h-[48px]" />}
  </div>
);

export default VehiclesYouMightLikeLoader;
